// extracted by mini-css-extract-plugin
export default {"wrapper":"tabButton_wrapper__NWLV+","tab":"tabButton_tab__Qtw+v","tabActive":"tabButton_tabActive__A79UW","iconWrapper":"tabButton_iconWrapper__dB8IF","text":"tabButton_text__JXY0-"};